<template>
 <div style="box-shadow: none; background-color: #fff; border-radius: 8px; border: 1px solid #ddd; min-height: 480px; height: calc(100vh - 190px);">
     
   <v-container fluid> 
        <v-row style="top: 60px; position: fixed; z-index:10; background-color: #f8f8f8; padding-top:4px; margin-left: -30px; width:100%" v-if="!apiLoading">
            <v-col cols="12" style="display:flex" float="left">
                <h2 v-if="currentModule.title">{{st(currentModule.title)}}
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="grey lighten-1" style="cursor:pointer;" class="pl-1 pointer" dense v-bind="attrs" v-on="on">info</v-icon>
                            </template>
                            <span>{{st(currentModule.description)}}</span>
                            </v-tooltip>
                        </h2>
            </v-col>
        </v-row>

        <v-row  v-if="this.accessAllowed">
            <v-col cols="2">
            </v-col>
            <v-col cols="8">
                 <v-combobox v-model="searchPrompt" :items="searchHistory" 
                        outlined dense placeholder="Introduce tu búsqueda" ref="searchInput" @change="doSearch">
                         <template v-slot:prepend-item>
                        <v-list-item class="grey--text">
                            <i ref="searchIcon" class="material-icons" style="cursor: pointer;">search</i>Aquí tienes algunas sugerencias
                        </v-list-item>
                    </template>
                 </v-combobox>
            </v-col>
            <v-col cols="1">
                <v-btn icon color="primary" @click="doSearch"><v-icon>search</v-icon></v-btn>
            </v-col>
        </v-row>



        <v-row v-if="apiLoading">
            <v-col cols="12" >
                <v-skeleton-loader
                type="table-tbody"
                ></v-skeleton-loader>
            </v-col>
        </v-row>


        <v-row  v-if="!apiLoading && this.accessAllowed && currentAISearch" style="margin-top:-30px; padding:0 30px;">
             <v-col cols="12">
                    <v-data-table  :loading="isLoading" :disableFiltering="true"
                        :headers="headers" 
                        ref = "dataTable"
                        :loading-text="$t('wkt.admin.common.table.loading')"
                        :no-data-text="$t('wkt.admin.common.table.no_data')"
                        :no-results-text="$t('wkt.admin.common.table.no_results')"
                        :options.sync="options" 
                        :server-items-length="serverItems"
                        :disablePagination="true" 
                        :items="data" 
                        :fixedHeader="true" 
						:height="tableHeight" 
						style="max-height: calc(100vh - 130px); width: 100%;"
                        :footer-props="{
                            'items-per-page-text': $t('wkt.admin.common.table.items_per_page'),
                            'items-per-page-all-text': $t('wkt.admin.common.table.items_per_page_all'),
                            'items-per-page-options': [20, 50, 100],
                        }"
                    ></v-data-table>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="12" v-if="!this.accessAllowed && !isLoading">
                <div class="transparent empty-state center-align">
                    <div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
                        <div class="text-center">
                            <i class="large material-icons" style="cursor: pointer;">table_chart</i>
                            <h4>{{ $t('wkt.admin.em.main.empty-title') }}</h4>
                            <p>{{ $t('wkt.admin.em.main.empty-subtitle') }}</p>
                        </div>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" v-if="this.accessAllowed && !currentAISearch">
                <div class="transparent empty-state center-align">
                    <div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
                        <div class="text-center">
                            <i class="large material-icons" style="cursor: pointer;">memory</i>
                            <h4>AI Search es un servicio experimental basado en OpenAI</h4>
                            <p>Introduce tu búsqueda en lenguaje natural<br>Puedes realizar consultas sobre tu plantilla, vacaciones y checkin</p>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
    <ExportXlsx
                    ref="exportXlsx"
                    style ="visibility:hidden;"
                    :data="data"
                    :columns="headers"
                    :filename="'tweem_export'"
                    :sheetname="'tweem'"
                    >
                </ExportXlsx>
        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                <span style="color: #ffffff;">{{alertText}}</span>
                <v-btn text @click="showAlert=false">
                <span style="color: #ffffff;">{{$t('wkt.admin.common.dialog-buttons.close')}}</span>
                </v-btn>
            </v-snackbar>

          
    </v-container>  
     <v-btn class="mt-n4 ml-4 material-button" color="primary" dark @click="exportData" v-if="data && data.length>0"
                style="position: fixed; bottom:22px; right: 30px;
                       background-color: transparent !important;
                       color: #185ea9 !important;
                       text-transform: uppercase; 
                       letter-spacing: 0!important;
                       padding: 0 10px!important;
                       padding-right: 0 !important;
                       font-size: .9rem !important;
                       line-height: 36px !important;
                       box-shadow: none !important;
                       font-weight: normal !important;"
                >
                    <v-icon
                    small
                    class="mr-2">file_download</v-icon>
                    {{ $t('wkt.admin.qbuilder.data-viewer.export') }}
                </v-btn>
 </div>
</template>

<script> 
// eslint-disable-next-line no-unused-vars
import gwt from '../../api/gwt'
import api from '../../api/worktime'
import ExportXlsx from '../common/ExportXlsx';
import BaseModule from '../common/BaseModule.js'
import CommonFormatter from '../common/CommonFormatter.js'
import AISearchModel from './aisearch/AISearchModel.js'

export default {
  name: 'AISearchModule',
mixins: [BaseModule, CommonFormatter],
  components: { ExportXlsx
  },

  data () {
      return { 
         currentModule: { title:"AI Search",
                          description: "AI Search provided by OpenAI - BETA"},
         accessAllowed: false,
         apiLoading: true,
         isLoading: true,
        showAlert: false,
        alertColor: 'error',
        headers: [{ text: 'id', value: 'id' }],
        alertText: '',
        serverItems: 10,
        data: [],
        options: { page: 1, sortBy:[], sortDesc:[]},
        context: {},
        currentAISearch: null,
        tableHeight: undefined,
        searchPrompt: null,
        searchHistory: ['nombre de los trabajadores sin acceso','total de trabajadores por departamento', 'total de horas adicionales por departamento en los últimos 30 días', 'trabajadores con vacaciones el 20/3/2022',
        'trabajadores que han trabajado más de 40 horas en los últimos 7 días','trabajadores con más de 20 días de vacaciones pendientes en el departamento de \'Administración\''],
        alertTimeout: 3000
      }
    },
    watch: {
      options: {
        handler () { 
            this.loadData();
        },
        deep: true,
      },
    },
  methods: {
    parseHeaders(data) {
        if (!data || data.length==0) {
            this.headers=[];
            return;
        }

        let headers = Object.keys(data[0]).map(k=> {return this.getHeaderForField(k) });
        headers.sort(function(a, b) {
            if (a.weight && b.weight) {
                return b.weight - a.weight
            }
            return 0;
        });
        this.headers = headers;

    },
    getHeaderForField(field) {
        let header = AISearchModel.columns.find(col => col.field == field);
        if (header) {
            header.label = this.$t(header.label);
            header.text = this.$t(header.text);
            header.value = field;
            return header;
        }
        header = {text:field, value:field, label:field, field:field, weight:1};
        switch (field) {
            case 'id':
                header.text='Id';
                header.weight=999;
                break;
            case 'employee_id':
                header.text='Id trabajador';
                header.weight=998;
                break;
            case 'firstname':
                header.text='Nombre';
                header.weight=997;
                break;
            case 'lastname':
                header.text='Apellidos';
                header.weight=996;
                break;
            case 'creation_date':
            case 'create_date':
                header.text='Fecha creación';
                header.weight=995;
                header.formatter='formatDateTime';
                break;
            case 'last_access':
                header.text='Último acceso';
                header.weight=994;
                header.formatter='formatDateTime';
                break;
            case 'birthday':
                header.text='F. nacimiento';
                header.weight=990;
                header.formatter='formatDate';
                break;
            case 'from_date':
                header.text='Desde';
                header.weight=985;
                header.formatter='formatDate';
                break;
            case 'to_date':
                header.text='Hasta';
                header.weight=984;
                header.formatter='formatDate';
                break;
            case 'employment_contract_start_date':
                header.text='Inicio contrato';
                header.weight=980;
                header.formatter='formatDate';
                break;
            case 'employment_contract_end_date':
                header.text='Fin contrato';
                header.weight=979;
                header.formatter='formatDate';
                break;
            default:
        }

        return header;
    },

    doSearch() {
        this.$nextTick(() => {
            this.executeSearch();
            this.$refs.searchInput.blur();
        });
    },
    executeSearch() {
        this.isLoading = true;
        const me = this;
        me.currentAISearch = {};
        this.data=[];
        this.headers=[];
        api.doAISearch("STAFF",this.searchPrompt,
                    res => {
                            me.currentAISearch=res;
                           if (me.options.page!=1) {
                                me.options.page=1;
                            } else {
                                me.loadData();
                            }
                    }, err => {
                            me.isLoading = false;
                            me.currentAISearch = undefined;
                            me.data = [];
                            console.log(err);
                            me.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
                    });
    },
    loadData() {
                if (!this.currentAISearch ||  !this.currentAISearch.id) {
                    this.isLoading = false;
                    return;
                }
                this.isLoading = true;
                const me = this;
                const { sortBy, sortDesc, page, itemsPerPage } = this.options;

                let searchContext = {
                    'sortBy':sortBy.length>0?sortBy[0]:null,
                    'sortDesc':sortDesc.length>0?sortDesc[0]:null,
                    workplaceIds: this.context.workplaceIds,
                    departmentIds: this.context.departmentIds,
                    offset: (page-1) * itemsPerPage,
                    count: itemsPerPage
                };
                api.getAISearchData(this.currentAISearch.id, searchContext,
                    data => {
                            console.log(data);

                            me.isLoading = false;
                            me.parseHeaders(data);
                            me.data = me.formatData(me,data);
                            me.fixLayout(me);
                            me.serverItems = (page-1) * itemsPerPage + data.length + (itemsPerPage == data.length?1:0)
                            
                    }, err => {
                            me.apiLoading = false;
                            me.data = [];
                            console.log(err);
                            me.isLoading = false;
                            me.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
                    });
    },
    // eslint-disable-next-line no-unused-vars
    onReveal(payload) {

        let profile = gwt.getSessionProfile();
        let sessionInformation = gwt.getSessionInformation();
        let isSuperAdmin = sessionInformation?sessionInformation.employee.isSuperAdmin:false;
    
        //revisamos permisos
        this.accessAllowed = (isSuperAdmin || !this.currentModule.rolesAllowed || this.matchRole(profile,this.currentModule.rolesAllowed.split(',')));
        
        this.apiLoading = false;
        this.isLoading = false;
        
    },
    fixLayout(vm) {
        this.$nextTick(() => {
            vm.tableHeight = window.getComputedStyle(vm.$refs.dataTable.$el, null).getPropertyValue("max-height")-190;
        });
    },
    doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
   exportData() {
        this.$refs.exportXlsx.$el.click();
    },
  }
}
</script>


<style lang="scss" scoped>
.foo {
    .bar {
        display: block;
        background-color: red;
    }
}
</style>
